import React from "react";
import { Lock, Crown } from "lucide-react";

/**
 * Beautiful blurred premium overlay used on top of locked content.
 * Caller wraps the locked region with `relative` and renders this inside.
 */
export default function LockedOverlay({ title = "Premium Feature", subtitle, onUnlock, testId = "locked-overlay" }) {
  return (
    <div className="locked-overlay" data-testid={testId}>
      <div
        className="w-14 h-14 rounded-full flex items-center justify-center mb-3"
        style={{ background: "linear-gradient(135deg, #C9975A 0%, #E3BA85 100%)" }}
      >
        <Lock size={22} className="text-white" strokeWidth={1.8} />
      </div>
      <p className="text-xs uppercase tracking-[0.2em] text-gold font-medium mb-1">
        Glow Premium
      </p>
      <h3 className="text-2xl text-cocoa font-serif mb-2">{title}</h3>
      {subtitle && (
        <p className="text-sm font-light text-cocoa/70 max-w-[260px] mb-5">
          {subtitle}
        </p>
      )}
      <button
        data-testid={`${testId}-unlock`}
        onClick={onUnlock}
        className="rounded-full px-6 py-3 text-sm font-medium text-white inline-flex items-center gap-2"
        style={{ background: "linear-gradient(135deg, #C9975A 0%, #E3BA85 100%)", boxShadow: "0 4px 16px rgba(201,151,90,0.3)" }}
      >
        <Crown size={14} />
        Unlock Premium
      </button>
    </div>
  );
}
